/**
 * TimelineMonthLabels Component
 *
 * Renders month header row with labels spanning multiple weeks.
 * Uses foreignObject to render MUI Typography inside SVG.
 */

import React from 'react'
import { Typography, useTheme } from '@mui/material'

/**
 * TimelineMonthLabels - Month header labels
 *
 * @param {Object} props
 * @param {Object} props.months - Month mapping { monthKey: weekCount }
 * @param {number} props.weekWidth - Pixels per week
 */
export const TimelineMonthLabels = ({ months, weekWidth }) => {
  const theme = useTheme()

  // Reduce months to positioned elements
  const elements = Object.entries(months).reduce((acc, [month, weekCount]) => {
    const x = acc.offset
    acc.offset += weekCount * weekWidth

    acc.elements.push(
      <g key={month}>
        <rect
          x={x}
          y={0}
          width={weekCount * weekWidth}
          height={30}
          fill={theme.palette.background.paper}
          stroke="#ddd"
        />
        <foreignObject
          x={x + 5}
          y={13}
          width={weekCount * weekWidth - 10}
          height={20}
        >
          <Typography
            sx={{
              fontSize: '10px',
              fontWeight: 600,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}
          >
            {month}
          </Typography>
        </foreignObject>
      </g>
    )

    return acc
  }, { offset: 0, elements: [] })

  return <>{elements.elements}</>
}
